import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { AlertService } from '../../providers/alert-service';
import { ModalTiposIrregularidadesPage } from '../modais/modal-tipos-irregularidades/modal-tipos-irregularidades';
import { TiposIrregularidadesService } from '../../providers/tipos-irregularidades-service';

/*
  Generated class for the TiposIrregularidade page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-tipos-irregularidades',
  templateUrl: 'tipos-irregularidades.html',
  providers: [
    TiposIrregularidadesService
  ]
})
export class TiposIrregularidadesPage {

  listaIrregularidades: any;
  loading: any = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, public tiposIrregularidadesService: TiposIrregularidadesService, public modalCtrl: ModalController, public alertService: AlertService) {
    this.carregarPagina();
  }

  carregarPagina() {
    this.tiposIrregularidadesService.listarTiposIrregularidades().subscribe(data => {
      this.listaIrregularidades = data;
      this.loading = false;
    }, error => {
      this.alertService.mostraAlerta("", "Hove um erro ao listar as irregularidades.");
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  deletarIrregularidade(idIrregularidade) {
    this.loading = true;
    this.tiposIrregularidadesService.deletarTipoIrregularidade(idIrregularidade).subscribe(data => {
      this.alertService.mostraAlerta("", "Irregularidade deletada com sucesso!");
      this.carregarPagina();
    }, error => {
      this.alertService.mostraAlerta("", "Hove um erro ao remover irregularidade.");
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  inserirNovaIrregularidade() {
    let parametroEnviado = this.tiposIrregularidadesService.criaIrregularidade();
    this.mostrarModal("Cadastro de Irregularidade", parametroEnviado);
  }

  editarIrregularidade(parametroEnviado) {
    this.mostrarModal("Edição de Irregularidade", parametroEnviado);
  }

  mostrarModal(titulo, parametroEnviado) {
    let modal = this.modalCtrl.create(ModalTiposIrregularidadesPage, { param1: titulo, param2: parametroEnviado });
    modal.onDidDismiss(retornoModal => {
      this.loading = true;
      this.carregarPagina();
    });
    modal.present();
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");
      let numberOfWordsToTruncate = 10;

      return separatedByWords.length >= numberOfWordsToTruncate;
    }
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }


}



// WEBPACK FOOTER //
// ./src/pages/tipos-irregularidades/tipos-irregularidades.ts